export default { sha: '180c8eba84b1d18414303d2255a91028295a4ed2', buildNumber: 'undefined' }
